import { render, staticRenderFns } from "./MultipleSelectDropdown.vue?vue&type=template&id=06df3cba"
import script from "./MultipleSelectDropdown.vue?vue&type=script&lang=ts"
export * from "./MultipleSelectDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports